module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loginbg"
    }
  }, [_vm._v("  ·\n  "), _c('div', {
    attrs: {
      "id": "ding"
    }
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "id": "wenzi"
    }
  }, [_vm._v("\n      自提系统\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "zhanghao"
    }
  }, [_vm._v("\n      账号\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "tuichu"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n      【退出】\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "yuyue"
    },
    on: {
      "click": _vm.tiaozhuanyuyue
    }
  }, [_vm._v("\n      预约\n    ")])]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-position": "left",
      "label-width": "0px",
      "id": "products"
    }
  }, [_c('div', {
    attrs: {
      "id": "lujingkongzhi"
    }
  }, [_c('img', {
    attrs: {
      "id": "lujing",
      "src": require("../../assets/lujing.png")
    }
  })]), _vm._v(" "), [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }), _vm._v(" "), _c('el-carousel', {
    attrs: {
      "trigger": "click",
      "height": "300px"
    }
  }, _vm._l((_vm.imgList), function(item) {
    return _c('el-carousel-item', {
      key: item.id
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "id": "product1",
        "src": item.url
      }
    })])
  }), 1)], 1)], _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goReservationOrder
    }
  }, [_vm._v("下一步")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7089030c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cdwgkj/CardProduct.vue
// module id = 600
// module chunks = 1